import React from "react";
import Link from "gatsby-link";
import Helmet from "react-helmet";
import styled from "styled-components";
import { getGraphNode } from "../../selectors";

import NavBar from "../../components/NavBar";
import { H1, H2, H3, H4, H5, Description } from "../../components/typography";
import Section from "../../components/blocks/Section";
import Pad from "../../components/blocks/Pad";
import { ShowMobile, HideMobile } from "../../components/blocks/Responsive";
import Background from "../../components/blocks/Background";
import { PostThumbnail, PostFeature } from "../../components/Post";

import SpermImage from "../../../assets/sperm.png";
import favicon from "../../../assets/logofavcon@2x.png";

const LogoRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

const LogoImg = styled.img`
  max-height: 60px;
  max-width: 140px;
  padding: 20px;
  filter: grayscale(100%);
  mix-blend-mode: multiply;
  transition: filter 300ms;
  :hover {
    filter: grayscale(0%);
  }
`;

export default ({ data }) => {
  const content = getGraphNode(data, "NewsPage");
  const posts = content.blogPost;
  posts.sort((a, b) => new Date(b.publishDate) > new Date(a.publishDate));
  const press = content.pressMentions;
  return (
    <div>
      <Helmet
        title="Contraline News"
        meta={[{ name: "Contraline", content: "News" }]}
      >
        <link rel="icon" type="image/png" href={favicon} />
      </Helmet>
      <NavBar color="dark" background="greyLight" />
      <Background color="greyLight" fixed={true}>
        <HideMobile>
          <Section noBorder fixed={true} vPad={false}>
            <Link>
              <PostFeature post={posts[0]} />
            </Link>
          </Section>
        </HideMobile>
        <Section fixed style={{ paddingBottom: "2.8rem" }}>
          <H5
            align="center"
            style={{ paddingBottom: "0.5rem", fontWeight: 700 }}
          >
            Featured In
          </H5>
          <LogoRow>
            {press.map(p =>
              <a href={p.link}>
                <LogoImg src={p.logo.file.url} />
              </a>
            )}
          </LogoRow>
        </Section>
        <Section fixed>
          <HideMobile>
            <Pad h={2} v={1} />
            {posts
              .slice(1)
              .map((post, index) =>
                <PostThumbnail post={post} index={index} />
              )}
          </HideMobile>
          <ShowMobile>
            {posts.map((post, index) =>
              <PostThumbnail post={post} index={index} />
            )}
          </ShowMobile>
        </Section>
      </Background>
    </div>
  );
};

export const pageQuery = graphql`
  query NewsPageQuery {
    allContentfulNewsPage {
      edges {
        node {
          blogPost {
            id
            title
            subtitle
            author
            publishDate(formatString: "MMMM DD, YYYY HH:MM:SS")
            headerImage {
              id
              responsiveResolution(width: 1200, quality: 70) {
                src
              }
            }
            body {
              body
            }
          }
          pressMentions {
            id
            link
            logo {
              file {
                url
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/news/index.js